import React, { useContext } from 'react';
import { usePostOfficeBottomSheetState } from '@apps/admin/postOffice/PostOffice.bottomSheet';
import { PeopleContext } from '@shared/context/people';
import { Flex, TextV2, IconV2 } from '@withjoy/joykit';
import { SelectRecipientsEmail } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { PeoplePickerButton } from '@shared/components/PeoplePicker';
import { usePostOfficeTelemetry } from '@apps/admin/postOffice/PostOffice.telemetry';
import { getPostOfficeDraftType } from '@apps/admin/postOffice/PostOffice.utils';
import { useQueryParamHelper } from '@shared/core/queryString';

const SelectRecipientsView: React.FC = () => {
  const { descriptionOffsetTransform, parentViewState } = usePostOfficeBottomSheetState();
  const { selectedPeople } = useContext(PeopleContext);
  const telemetry = usePostOfficeTelemetry();
  const { getValueString } = useQueryParamHelper();
  const draftType = getPostOfficeDraftType(getValueString('draftType'));
  const { t, tq } = useTranslation('postOffice');
  const tBottomSheet = t('bottomSheet');
  const tSelectRecipients = tBottomSheet.selectRecipients;

  const guestsDescription = tq.plural(selectedPeople.length, {
    zero: tq`No guests selected yet.`,
    one: tq`1 guest selected.`,
    other: tq`${selectedPeople.length} guests selected.`,
  });

  const handleStartSelection = () => {
    telemetry.selectGuestsClicked(draftType);
  };

  const buttonText = selectedPeople.length ? tSelectRecipients.editGuests() : tSelectRecipients.addGuests();

  return (
    <Flex
      flexDirection="column"
      padding={6}
      paddingBottom={0}
      height="100%"
    >
      <TextV2
        marginBottom="8px"
        typographyVariant="hed4"
        color="mono14"
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="24px"
      >
        <IconV2
          size="md"
          marginRight="12px"
        >
          <SelectRecipientsEmail />
        </IconV2>{' '}
        {tSelectRecipients.title()}
      </TextV2>
      <TextV2
        marginBottom={6}
        paddingX={4}
        textAlign="center"
        typographyVariant="body1"
        color="mono12"
        flex="1"
        style={{ transform: descriptionOffsetTransform }}
      >
        {guestsDescription}
      </TextV2>
      <PeoplePickerButton
        eventHandle={parentViewState.eventHandle}
        itemType="withDeliveryMethod"
        enableSmsSelection={false}
        initialDeliveryMethod="email"
        allowUnreachableSelection
        title={
          <TextV2
            typographyVariant="hed4"
            color="mono14"
            display="flex"
            alignItems="center"
            fontSize="24px"
            lineHeight="1"
          >
            <IconV2
              size="md"
              marginRight="12px"
            >
              <SelectRecipientsEmail />
            </IconV2>{' '}
            {tq`Select Guests`}
          </TextV2>
        }
        buttonTextDefault={buttonText}
        buttonTextHover={buttonText}
        intent="neutral"
        variant="outline"
        onStartSelection={handleStartSelection}
        useCase={{ area: 'postOffice', subArea: 'selectRecipients' }}
      />
    </Flex>
  );
};

export default SelectRecipientsView;
